import ProfileItemForm from "./ProfileItemForm";
import React from "react";
import ProfileJobRow from "../../profiles/components/ProfileJobRow";

export default class JobForm extends ProfileItemForm {

    static ItemType = 'Job'

    static FormClass = 'talent-role-form add-talent-form add-company-form '

    static ShowProfilePreview = true;

    getModelFromProps() {
        let model = {...(this.props.model || {})};

        model.is_still_there = (model.is_still_there === 1);
        if (model.started_at) {
            if(typeof model.started_at === 'string') {
                model.started_at = new Date(model.started_at)
            }
            model.started_at_year = model.started_at.getFullYear();
            model.started_at_month = model.started_at.getMonth() + 1;

            if (!model.ended_at && !model.is_still_there) {
                model.is_still_there = true;
            }
        }
        if (model.ended_at) {
            if(typeof model.ended_at === 'string') {
                model.ended_at = new Date(model.ended_at)
            }
            model.ended_at_year = model.ended_at.getFullYear();
            model.ended_at_month = model.ended_at.getMonth() + 1;
        }

        return model;
    }

    creatingNewItem() {
        let {
            is_still_there,
            ...model
        } = this.getModelFromProps();
        return !TB.keys(model).length;
    }

    async onChange(model) {

        let updatedModel = {
            ...model,
            ...this.setDateFromInputs(model, 'started_at'),
            ...this.setDateFromInputs(model, 'ended_at'),
        }
        let resetEndedAtValidation = false;
        if (updatedModel.is_still_there || (!updatedModel.is_still_there && this.state.model.is_still_there)) {
            resetEndedAtValidation = true;
            delete updatedModel.ended_at;
            delete updatedModel.ended_at_year;
            delete updatedModel.ended_at_month;

            if (this.getModelFromProps().ended_at) {
                await this.formRef.current.updateInputsWithValue({ended_at_year:'', ended_at_month:''}, false)
            }
        }

        // if (!updatedModel.ended_at_year && updatedModel.ended_at_month && updatedModel.ended_at_month !== '') {
        //     delete updatedModel.ended_at_month;
        //     await this.formRef.current.updateInputsWithValue({ended_at_month:''}, false)
        // }
        // if (!updatedModel.started_at_year && updatedModel.started_at_month && updatedModel.started_at_month !== '') {
        //     delete updatedModel.started_at_month;
        //     await this.formRef.current.updateInputsWithValue({started_at_month:''}, false)
        // }
        await super.onChange(updatedModel);


        let errors = {
            ...this.validateDateBeforeToday('started_at', 'Start date'),
            ...this.validateDateAfterDate('ended_at', 'started_at')
        };

        if (resetEndedAtValidation) {
            errors.ended_at = null
        }else if(errors.ended_at === null) {
            errors = TB.merge(errors,{
                ...this.validateDateBeforeToday('ended_at', 'End date'),
            });
        }

        if (Object.keys(errors).length) {
            await this.formRef.current.updateInputsWithError(errors)
        }

    }

    /**
     * The fields mapping for the form
     */
    formFields = () => {

            // 'jobs.*.employer'       => 'required|string|max:255',
            // 'jobs.*.image_path'     => 'nullable|string|max:255', OR 'nullable|image',
            // 'jobs.*.description'    => 'nullable|string|max:255',
            // 'jobs.*.role'           => 'required|string|max:255',
            // 'jobs.*.is_still_there' => 'nullable|boolean',
            // 'jobs.*.started_at'     => 'required|date',
            // 'jobs.*.ended_at'       => 'nullable|date',


        return [
            {
                style: styles.fieldSection,
                fields: {
                    employer: {
                        type: 'text',
                        label: TB.trans('talent.company_form.employer_label'),
                        maxLength: 255,
                        required: true,
                        placeholder: TB.trans('talent.company_form.employer_placeholder'),
                        style: styles.field,
                        columns: 10
                    }
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    role: {
                        type: 'text',
                        label: TB.trans('talent.company_form.role_label'),
                        maxLength: 255,
                        required: true,
                        placeholder: TB.trans('talent.company_form.role_placeholder'),
                        style: styles.field,
                        columns: 10
                    }
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    started_at: {
                        type: 'hidden-date',
                        label: TB.trans('talent.company_form.start_date_label'),
                        required: false,
                        style: styles.field,
                        className: 'field hide-input',
                        columns: 10
                    }
                }
            },
            {
                style: styles.fieldSection,
                className: 'field-section field-section-select',
                fields: {
                    started_at_month: {
                        label: false,
                        placeholder: 'Month',
                        type: 'select',
                        required: false,
                        options: this.monthOptions(),
                        labelClassName: 'hide-label',
                        className: 'field hide-label',
                        style: {...styles.field, paddingRight: 0, maxWidth: 110},
                        hideVisibility: !this.props.isEditing && !this.state.model.started_at_month
                    },
                    started_at_year: {
                        label: false,
                        placeholder: 'Year',
                        type: 'select',
                        required: parseInt(this.state.model.started_at_month) > 0,
                        labelClassName: 'hide-label',
                        options: this.yearOptions(),
                        validations: {

                            need_year: ({model}, value) => {
                                if (model.started_at_month && (value === '' || TB.isNaN(value))) {
                                    return 'Year is required with a month'
                                }

                                return true;
                            }
                        },
                        style: {...styles.field,  maxWidth: 110},
                        hideVisibility: !this.props.isEditing && !this.state.model.started_at_year
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    ended_at: {
                        type: 'hidden-date',
                        label: TB.trans('talent.company_form.end_date_label'),
                        required: false,
                        style: styles.field,
                        className: 'field hide-input',
                        columns: 10,
                        hideVisibility: (!this.props.isEditing && !this.state.model.ended_at) ||
                            (this.props.isEditing && this.state.model.is_still_there)
                    }
                }
            },
            {
                style: styles.fieldSection,
                className: 'field-section field-section-select',
                fields: {
                    ended_at_month: {
                        label: false,
                        placeholder: 'Month',
                        type: 'select',
                        required: false,
                        options: this.monthOptions(),
                        labelClassName: 'hide-label',
                        className: 'field hide-label',
                        style: {...styles.field, paddingRight: 0, maxWidth: 110},
                        hideVisibility: (!this.props.isEditing && !this.state.model.ended_at_month) ||
                            (this.props.isEditing && this.state.model.is_still_there)
                    },
                    ended_at_year: {
                        label: false,
                        placeholder: 'Year',
                        type: 'select',
                        required: parseInt(this.state.model.ended_at_month) > 0,
                        labelClassName: 'hide-label',
                        validations: {

                            need_year: ({model}, value) => {
                                if (model.ended_at_month && (value === '' || TB.isNaN(value))) {
                                    return 'Year is required with a month'
                                }

                                return true;
                            }
                        },
                        options: this.yearOptions(),
                        style: {...styles.field, maxWidth: 110},
                        hideVisibility: (!this.props.isEditing && !this.state.model.ended_at_year) ||
                            (this.props.isEditing && this.state.model.is_still_there)
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    is_still_there: {
                        label: TB.trans('talent.company_form.still_employed_label'),
                        type: 'checkbox',
                        required: false,
                        style: styles.field,
                        columns: 4,
                        hideVisibility: !this.props.isEditing && !this.state.model.is_still_there
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    image_path: {
                        label: TB.trans('talent.company_form.company_logo_label'),
                        type: 'pixie',
                        ratio: '1:1',
                        freeCrop: true,
                        minWidth: 50,
                        minHeight: 50,
                        width: 200,
                        circular: false,
                        required: false,
                        style: styles.field,
                        columns: 8,
                        hideVisibility: !this.props.isEditing && !this.state.model.image_path
                    },
                }
            },
            {
                style: styles.fieldSection,
                fields: {
                    description: {
                        label: TB.trans('talent.company_form.summary_paragraph_label'),
                        placeholder: TB.trans('talent.company_form.summary_paragraph_placeholder'),
                        type: 'textarea',
                        required: false,
                        style: styles.field,
                        maxLength: 10000,
                        columns: 10,
                        rows: 10
                    },
                }
            },
        ];
    };

    renderProfilePreview() {
        return (
            <div className="px-4 mx-0 self-start">
                <ProfileJobRow job={this.getModelFromProps()}/>
            </div>
        )
    }
}

const styles = {
    fieldSection: {
        flexDirection: 'row'
    },
    field: {
        padding: '0 15px',
    },
};